export const typography = {
  body: {
    paragraph: {
      fontSize: 16,
      lineHeight: '24px',
      letterSpacing: 0.5
      // color: '$gray900',
      // fontWeight: 400
    }
  }
}
